import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { ROUTE_PERMISSIONS } from "../../constants/permissions";
import { selectAuthUser } from "../../redux/auth/authSlice";
import { hasPermission } from "../../utils/permissions";
import { isSuperAdmin } from "../../utils/userRole";

function PermissionRoute({ permission: permissionProp, children }) {
  const user = useSelector(selectAuthUser);
  const location = useLocation();
  const path = location.pathname.replace(/\/+$/, "") || "/";
  const required = permissionProp ?? ROUTE_PERMISSIONS[path];

  if (isSuperAdmin(user) || required === null || required === undefined) {
    return children ?? <Outlet />;
  }

  if (hasPermission(user, required)) {
    return children ?? <Outlet />;
  }

  return <Navigate to="/" replace state={{ forbidden: path }} />;
}

export default PermissionRoute;
